/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skilltemplates1Inputs */

const en_entity_skilltemplates1 = /** @type {(inputs: Entity_Skilltemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Templates`)
};

const de_entity_skilltemplates1 = /** @type {(inputs: Entity_Skilltemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen`)
};

/**
* | output |
* | --- |
* | "Skill Templates" |
*
* @param {Entity_Skilltemplates1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skilltemplates1 = /** @type {((inputs?: Entity_Skilltemplates1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skilltemplates1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skilltemplates1(inputs)
	return de_entity_skilltemplates1(inputs)
});
export { entity_skilltemplates1 as "entity_skillTemplates" }